export type BlankString = string & ``

export const UTILS = {
  BLANK: '',
  SPACE: ' ',
  SLASH: '/',
  QUICK_MESSAGE_TRIGGER: '!',
  ELLIPSIS: '...',
  COMMA: ',',
  DASH: '-',
  DOT: '.',
  PLUS: '+',
  QUESTION_MARK: '?',
  EQUAL: '=',
  AT: '@',
  AMPERSAND: '&',
  PASSWORD_MIN_LEN: 8,
  STRING_MAX_LEN: 255,
  MAX_STAGE_ATTACHMENTS: 3,
  PARAMS: {
    ID: ':id',
    GROUP_ID: ':groupId',
    KEY: ':key',
    PURPOSE: ':purpose',
    REQUEST_ID: ':requestId',
    TAG_ID: ':tagId',
    NICHE_ID: ':nicheId',
    JOURNEY_ID: ':journeyId',
    COMMENT_ID: ':commentId',
    DEMAND_ID: ':demandId',
    USER_ID: ':userId',
    DEPARTMENT_ID: ':departmentId',
    CONVERSATION_ID: ':conversationId',
    MESSAGE_ID: ':messageId',
    clientId: ':clientId',
    TASK_ID: ':taskId',
    ACTIVITY_ID: ':activityId',
    FILE_KEY: ':fileKey',
    RECEIVABLE_ID: ':receivableId',
    PAYABLE_ID: ':payableId',
    ATTACHMENT_ID: ':attachmentId',
    CONTACT_ID: ':contactId',
    TRANSMISSION_LIST_ID: ':transmissionListId',
    WHATSAPP_INTEGRATION_ID: ':whatsappIntegrationId',
    secondaryUser_ID: ':secondaryUserId',
    CELL_PHONE: ':cellPhone',
    OWNER: ':owner',
    YEAR_MONTH: '?yearMonth=',
    TO_XLSX: '&toXlsx=true',
  },
}
